import RejMessages from "./../library/RejMessages";

export default class Voucher {
    constructor() {
        this.instance = self;
    }

    static init() {
        const self = new Voucher();
        self.attachEvents();
    }

    attachEvents() {
        const self = this;

        $(document).on("change", ".js-on-change-calculate-total", function () {
            self.refreshVoucherTotal();
        });

        $(document).on("click", ".js-on-click-apply-promo", function () {
            self.refreshVoucherTotal();
        });
    }

    refreshVoucherTotal() {
        const self = this;
        let $calculator = $(".voucher-calculator"),
            $tens = $calculator.find('[name="ten_vouchers"]'),
            $twenties = $calculator.find('[name="twenty_vouchers"]'),
            $fifthties = $calculator.find('[name="fifty_vouchers"]'),
            $deliveryOption = $calculator.find('[name="delivery_option"]'),
            $promoCode = $calculator.find('[name="promo_code"]'),
            data = {};

        oc.progressBar.show();

        data["ten_vouchers"] = $tens.val();
        data["twenty_vouchers"] = $twenties.val();
        data["fifty_vouchers"] = $fifthties.val();
        data["delivery_option"] = $deliveryOption.val();
        data["promo_code"] = $promoCode.val();

        oc.ajax("voucherOrder::onCalculateTotal", {
            data: data,
            update: { "vouchers/voucher-total": ".js-voucher-total" },
        })
            .catch((data) => {
                RejMessages.error(data.responseJSON.X_OCTOBER_ERROR_MESSAGE);
            })
            .finally(() => {
                oc.progressBar.hide();
            });
    }
}
